module.exports = __webpack_public_path__ + "media/images/activated-d8a56f41d1140b644db9f6f384d1d4bb.png";